import * as React from 'react'

import { styled } from '../../../../common/ui'
import { theme } from '../../theme'

type Variant = 'default' | 'info'
export class Modal extends React.Component<
  {
    variant?: Variant
    title: string
    children?: React.ReactNode
    asModal?: boolean
  },
  {}
> {
  static defaultProps = {
    asModal: true,
  }
  render() {
    const { children, title, variant, ...rest } = this.props
    return (
      <Cont variant={variant} {...rest}>
        <Title>{title}</Title>
        {children}
      </Cont>
    )
  }
}

const Cont = styled.div<{ variant?: Variant; asModal?: boolean }>`
  color: #fff;
  padding: 50px;
  background: ${props =>
    props.variant && props.variant === 'info'
      ? theme.colors.purple
      : theme.colors.green};
  ${props =>
    props.asModal && props.asModal === true
      ? `
      box-shadow: 0px 0px 23px #a2a2a2;
      position: absolute;
      top: 50px;
      left: 5%;
      right: 5%;`
      : ``};

  p {
    color: #fff;
  }
`
const Title = styled.h3`
  color: #fff;
  margin: 0;
  font-size: 36px;
  padding: 0 0 50px 0;
`
